<div class="fullscreen-container row" [ngSwitch]="etat">
  <div class="col-sm-12" *ngSwitchCase="'loaded'">
    <a routerLink="/motifsdecontact" class="bleu-caf ">
      <div class="d-block d-sm-block d-md-none bouton-retour cnaf-background1 cnaf-margin-mobile">
        <img alt="" src="/icfstatiquesangularappli/dist/images/burger_chevron_gauche_gris.png" />
        Retour
      </div>
    </a>
      <h2>Vous souhaitez être mis en relation avec
        votre Caf
      </h2>
      <button type="button"
      #appelCaf class="btn btn-secondary-cnaf btn-block btn-motifcontact margin"
      (click)="appelerMaCaf()">
      Appeler
    </button>
    <p>
    Ou vous pouvez poser vos questions à notre conseiller virtuel (bulle verte ci-dessous)
    </p>
  </div>
  <div class="col-sm-12 espacement" *ngSwitchCase="'loading'">
    <div class="progress">
      <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="40"
        aria-valuemin="0" aria-valuemax="100">
        Chargement en cours...
      </div>
    </div>
  </div>
</div>
